import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=1952eaac&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=1952eaac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1952eaac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1952eaac')) {
      api.createRecord('1952eaac', component.options)
    } else {
      api.reload('1952eaac', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=1952eaac&scoped=true&", function () {
      api.rerender('1952eaac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cS0i7i8aCvJ2/JS/comp/Voucher.vue"
export default component.exports